// src/components/Category.js
import React, { useEffect, useState } from "react";
import "./Category.css";
import { db } from "../firebase";                // <-- ton firebase.js
import { doc, getDoc } from "firebase/firestore";

import { useNavigate } from "react-router-dom";

export default function Category({onSelect }) {
  const navigate = useNavigate();
  const [active, setActive] = useState("");
  const [cats, setCats] = useState([]);         // [{id,label}]
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  useEffect(() => {
    let mounted = true;

    async function loadCategories() {
      try {
        setLoading(true);
        setErr("");

        // doc: collection "categories", document id "list"
        const snap = await getDoc(doc(db, "categories", "list"));
        if (!mounted) return;

        if (!snap.exists()) {
          setCats([]);
          setActive("");
          return;
        }

        // champ "data" = tableau d’objets { id,label, children:[{id,label}, ...] }
        const raw = snap.data()?.data ?? [];

        // 👉 on récupère uniquement les labels des children
        const children = raw.flatMap((node) => {
            const parent = node?.label ? [{ id: node.id ?? node.label, label: node.label.trim() }] : [];
            return [...parent];
          });

        // on enlève les vides + dédoublonnage éventuel sur label
        const clean = [];
        const seen = new Set();
        for (const it of children) {
          if (it.label && !seen.has(it.label)) {
            seen.add(it.label);
            clean.push(it);
          }
        }

        setCats(clean);
        setActive(clean[2]?.label || "");
      } catch (e) {
        console.error(e);
        setErr("Impossible de charger les catégories.");
      } finally {
        if (mounted) setLoading(false);
      }
    }

    loadCategories();
    return () => { mounted = false; };
  }, []);

  return (
    <div className="category-container">
      <div className="category-buttons">
        {loading && <span>Chargement…</span>}
        {err && <span style={{color:"#b91c1c"}}>{err}</span>}

        {!loading && !err && cats.slice(2 , 8).map((cat) => (
          <button
            key={cat.id}
            className={`category-btn ${active === cat.label ? "active" : ""}`}
            onClick={() => {
              setActive(cat.label);
              onSelect?.(cat.id, cat.label); // ⬅️ renvoie l'id et le label à Home
            }}
            title={cat.label}
          >
            {cat.label}
          </button>
        ))}
      </div>

      <button className="see-all" onClick={() => navigate('/products')}>Voir Tout</button>
    </div>
  );
}
